"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _polished = require("polished");
var _themeMapper = require("@gravity/theme-mapper");
var _jsxFileName = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Skeleton/lib/Skeleton.js",
  _templateObject,
  _templateObject2,
  _this = void 0;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_erfj2uxvd() {
  var path = "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Skeleton/lib/Skeleton.js";
  var hash = "31721cbbb6c5b23b7af70d9a60b18acb79886c3a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src883409340/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Skeleton/lib/Skeleton.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 26
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 10,
          column: 35
        },
        end: {
          line: 10,
          column: 65
        }
      },
      "2": {
        start: {
          line: 11,
          column: 32
        },
        end: {
          line: 11,
          column: 98
        }
      },
      "3": {
        start: {
          line: 16,
          column: 24
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "4": {
        start: {
          line: 24,
          column: 35
        },
        end: {
          line: 24,
          column: 61
        }
      },
      "5": {
        start: {
          line: 25,
          column: 32
        },
        end: {
          line: 25,
          column: 98
        }
      },
      "6": {
        start: {
          line: 45,
          column: 26
        },
        end: {
          line: 49,
          column: 1
        }
      },
      "7": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 10,
            column: 22
          },
          end: {
            line: 10,
            column: 23
          }
        },
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 65
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 19
          },
          end: {
            line: 11,
            column: 20
          }
        },
        loc: {
          start: {
            line: 11,
            column: 32
          },
          end: {
            line: 11,
            column: 98
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 24,
            column: 22
          },
          end: {
            line: 24,
            column: 23
          }
        },
        loc: {
          start: {
            line: 24,
            column: 35
          },
          end: {
            line: 24,
            column: 61
          }
        },
        line: 24
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 25,
            column: 19
          },
          end: {
            line: 25,
            column: 20
          }
        },
        loc: {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 98
          }
        },
        line: 25
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 26
          },
          end: {
            line: 45,
            column: 27
          }
        },
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 22
          }
        },
        line: 46
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 65
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 55
          }
        }, {
          start: {
            line: 10,
            column: 59
          },
          end: {
            line: 10,
            column: 65
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 11,
            column: 32
          },
          end: {
            line: 11,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 11,
            column: 32
          },
          end: {
            line: 11,
            column: 57
          }
        }, {
          start: {
            line: 11,
            column: 61
          },
          end: {
            line: 11,
            column: 98
          }
        }],
        line: 11
      },
      "2": {
        loc: {
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 98
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 25,
            column: 32
          },
          end: {
            line: 25,
            column: 57
          }
        }, {
          start: {
            line: 25,
            column: 61
          },
          end: {
            line: 25,
            column: 98
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "31721cbbb6c5b23b7af70d9a60b18acb79886c3a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_erfj2uxvd = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_erfj2uxvd();
var SkeletonContainer = (cov_erfj2uxvd().s[0]++, _styledComponents.default.div.attrs({
  className: 'g-Skeleton-container'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  background-color: ", ";\n  border-radius: ", ";\n  height: 35rem;\n  width:100%;\n"])), function (_ref) {
  var theme = _ref.theme;
  cov_erfj2uxvd().f[0]++;
  cov_erfj2uxvd().s[1]++;
  return (cov_erfj2uxvd().b[0][0]++, theme.contentBgColor) || (cov_erfj2uxvd().b[0][1]++, '#FFF');
}, function (_ref2) {
  var theme = _ref2.theme;
  cov_erfj2uxvd().f[1]++;
  cov_erfj2uxvd().s[2]++;
  return (cov_erfj2uxvd().b[1][0]++, theme.generalBorderRadius) || (cov_erfj2uxvd().b[1][1]++, _themeMapper.evolutionTheme.filterBar.borderRadius);
}));
var SkeletonWrapper = (cov_erfj2uxvd().s[3]++, _styledComponents.default.div.attrs({
  className: 'g-Skeleton-box'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  width:100%;\n  height: 35rem;\n  display: inline-block;\n  position: relative;\n  overflow: hidden;\n  background-color: ", ";\n  border-radius: ", ";\n\n  &:after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    transform: translateX(-100%);\n    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.2) 20%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 100%);\n    animation: shimmer 1s infinite;\n    content: '';\n  }\n  @keyframes shimmer {\n    100% {\n      transform: translateX(100%);\n    }\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  cov_erfj2uxvd().f[2]++;
  cov_erfj2uxvd().s[4]++;
  return (0, _polished.rgba)(theme.textColor, 0.1);
}, function (_ref4) {
  var theme = _ref4.theme;
  cov_erfj2uxvd().f[3]++;
  cov_erfj2uxvd().s[5]++;
  return (cov_erfj2uxvd().b[2][0]++, theme.generalBorderRadius) || (cov_erfj2uxvd().b[2][1]++, _themeMapper.evolutionTheme.filterBar.borderRadius);
}));
cov_erfj2uxvd().s[6]++;
var SkeletonIndicator = function SkeletonIndicator(props) {
  cov_erfj2uxvd().f[4]++;
  cov_erfj2uxvd().s[7]++;
  return /*#__PURE__*/_react.default.createElement(SkeletonContainer, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 3
    }
  }, /*#__PURE__*/_react.default.createElement(SkeletonWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 5
    }
  }));
};
var _default = exports.default = SkeletonIndicator;